import Ajax from "@/api/ajax";
export default{
    // 物流信息
    logisticsMsg(params) {
        return Ajax.post("/Home/logisticsMsg", params);
    },

}